/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
'use memo';
import React, { useState } from 'react';
import type { MiddleLabelContent } from '../interface';
import { FooterLink } from './FooterLink';
import styles from './FooterMiddle.module.scss';
import NextImage from '@/components/NextImage';
import { Button } from '@/components/Button';
import { useLabel } from '@/hooks/useLabels';

const chevron = '/images/footer/footer_down_arrow.svg';

export function MobileLinkColumn({
  title,
  middleLabelContent,
}: {
  title: string;
  middleLabelContent: MiddleLabelContent[];
}) {
  const columnName = title.split(' ')[0]?.toLowerCase() || '';
  const [isExpanded, setIsExpanded] = useState(false);
  const toggleExpandedState = () => setIsExpanded(!isExpanded);
  const lblExpansiblePanel = useLabel('label_ShelfPage_leftSideBar_ExpansiblePanel');

  return (
    <li className={styles.linkColumnContainer} data-testid={`footer_link_colum_${columnName}`}>
      <Button
        variant="ghost"
        customClass={`${styles.footerLinkDownArrow} ${styles.linkColumTitle}`}
        onClick={toggleExpandedState}
        data-testid={`footer_link_colum_title_${columnName}`}
        aria-expanded={isExpanded}
      >
        {title}
        <NextImage
          alt={`${title} ${lblExpansiblePanel}`}
          src={chevron}
          data-testid={`footer_link_colum_title_${columnName}`}
          className={`${styles.chevron} ${isExpanded ? styles.chevronUp : styles.chevronDown}`}
          width={22}
          height={12}
          loading="lazy"
        />
      </Button>
      <ul
        className={`${styles.linksContainer} ${isExpanded ? styles.showLinks : styles.hideLinks}`}
      >
        {middleLabelContent.map((content, index) => (
          <li key={`link_${index}`} className={styles.linkItem}>
            <FooterLink
              className={`${styles.linkItem} ${
                content.name.length > 30 ? styles.specialWidth : ''
              }`}
              {...content}
            />
          </li>
        ))}
      </ul>
      <hr className={styles.mobileLinkColumnHr} />
    </li>
  );
}
